module.exports = __webpack_public_path__ + "static/media/fruits_12.41aa03f2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_12.csv
// module id = 676
// module chunks = 0